import React, { useEffect, useState, useRef } from 'react';
import './ImageSlider.scss';

import { useNavigate } from 'react-router-dom';

const SliderComponent = ({
  images = [],
  duration = 3000,
  allowFade = true,
  showBullet = true,
  showArrowIcons = true,
  titleClass = '',
  descClass = '',
  containerWidth = '100%',
  containerHeight = '300px',
  headflash = [], // now an array of strings
  headflashstyle = '',
  headflashduration = 2000,
}) => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);
            // { image: img1, title: "", description: "",url:"/register" },


  const [currentHeadflashIndex, setCurrentHeadflashIndex] = useState(0);
  const headflashIntervalRef = useRef(null);

  const navigate = useNavigate();








  

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  const resetHeadflashInterval = () => {
    if (headflashIntervalRef.current) clearInterval(headflashIntervalRef.current);
  };

  useEffect(() => {
    // Slide image auto change
    resetTimeout();
    if (images.length > 0) {
      timeoutRef.current = setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
      }, duration);
    }
    return () => resetTimeout();
  }, [current, duration, images.length]);

  useEffect(() => {
    // Headflash text auto change
    resetHeadflashInterval();
    if (headflash.length > 1) {
      headflashIntervalRef.current = setInterval(() => {
        setCurrentHeadflashIndex((prev) => (prev + 1) % headflash.length);
      }, headflashduration);
    }
    return () => resetHeadflashInterval();
  }, [headflash, headflashduration]);

  const goToSlide = (index) => setCurrent(index);
  const prevSlide = () => setCurrent((current - 1 + images.length) % images.length);
  const nextSlide = () => setCurrent((current + 1) % images.length);


  // const openImageURL = (url) => {
  //   if (url) window.location.href = url;
  // };

const openImageURL = (url) => {
  if (url) navigate(url);
};


  if (images.length === 0) return null;

  return (
    <div
      className="slider-container"
      // style={{ width: containerWidth, height: containerHeight }}
      style={{ width: containerWidth, height: containerHeight }}
  
  
  >
      {/* Headflash text */}
      {Array.isArray(headflash) && headflash.length > 0 && (
        <div className={`slider-headflash ${headflashstyle}`}>
          <div
            key={currentHeadflashIndex}  // 👈 important
            className="headflash-fade"



          >
            {headflash[currentHeadflashIndex]}
          </div>
        </div>
      )}





      <div className="slider-inner-wrapper">
        {images.map((img, index) => {
          const slideClass = allowFade
            ? current === index
              ? 'fade-slide active-slide'
              : 'fade-slide inactive-slide'
            : current === index
            ? 'active-slide'
            : 'inactive-slide';

          return (
            <div 
              key={index} 
              className={`slide-item ${slideClass}`}
              onClick={() => openImageURL(img.url)}    //  👈 Click handler for URL
              style={{ cursor: img.url ? 'pointer' : 'default' }}              
              
              >
              <div className="slide-image-wrapper">
                <img
                  src={img.image}
                  alt={`slide-${index}`}
                  className="slide-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/assets/noimage.jpg';
                    e.target.style.objectFit = 'contain';
                  }}
                />
              </div>
              <div className="slide-content-overlay">
                <div className={`slide-title ${titleClass}`}>{img.title}</div>
                <div className={`slide-description ${descClass}`}>{img.description}</div>
              </div>
            </div>
          );
        })}
      </div>

      {showArrowIcons && (
        <>
          <button onClick={prevSlide} className="slider-arrow slider-arrow-left">
            &lt;
          </button>
          <button onClick={nextSlide} className="slider-arrow slider-arrow-right">
            &gt;
          </button>
        </>
      )}

      {showBullet && (
        <div className="slider-bullets">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`slider-bullet ${current === index ? 'active-bullet' : ''}`}
            ></button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SliderComponent;
